const SANDBOX_TOKEN = "sandbox-token-999";
const TESTING_TOKEN = "testing-token-000";
const DEMO_TOKEN = 'bridge-token-999';

module.exports = {
  DEMO_TOKEN,
  SANDBOX_TOKEN,
  TESTING_TOKEN
};
